import HourlyCostHistory from "./hourly-rate-history/hourly-cost-history";
import {EntityType} from "../../gd/const/item";
import {hourlyCost_onSessionEvent} from "./func/session-sync";
import TimeReport from "../time-report/time-report";
import HourlyCostHistoryCollection from "./hourly-rate-history/collection";

type UsersHourlyRateHistory = {
    [key: ID]: HourlyCostHistory[] // Here, both keys and values are of type string
}


export default class HourlyCost {

    private companyHourlyRateHistory    : HourlyCostHistory[]       = []
    private userHourlyRateHistory       : UsersHourlyRateHistory    = {}

    public hourlyCostHistoryCollection  : HourlyCostHistoryCollection


    constructor(hourlyRateHistoryRecords:JSONArray) {

        this.hourlyCostHistoryCollection = HourlyCostHistoryCollection.initFromJson(hourlyRateHistoryRecords)
        this.resetFromCollection()

        this.startSync()
    }

    destructor() {
        this.stopSync()
    }

    //

    public resetFromCollection() {

        this.companyHourlyRateHistory   = []
        this.userHourlyRateHistory      = {}

        _.map(this.hourlyCostHistoryCollection.models, (history:HourlyCostHistory)=>{
            this.addHourlyCostHistory(history)
        })
    }

    addHourlyCostHistory(hourlyCostHistory: HourlyCostHistory) {

        if (hourlyCostHistory.isCompany) {
            this.companyHourlyRateHistory.push(hourlyCostHistory)
        }

        if (hourlyCostHistory.isUser) {
            if (!this.userHourlyRateHistory[hourlyCostHistory.userId!]) {
                this.userHourlyRateHistory[hourlyCostHistory.userId!] = []
            }

            this.userHourlyRateHistory[hourlyCostHistory.userId!].push(hourlyCostHistory)
        }
    }

    // Calculations

    calculateServiceCost(timeReport:TimeReport) {
        // hourlyCost_calculateServiceCost(this, timeReport.reportedTimeHours, timeReport.date, timeReport.userId)
        return timeReport.reportedTimeHours * this.getUserServiceRate(timeReport.userId, timeReport.date || moment())
    }

    calculateLaborCost(timeReport:TimeReport) {

        return timeReport.reportedTimeHours * this.getUserLaborRate(timeReport.userId, timeReport.date || moment())
    }

    getUserLaborRate(userId:ID, date:Moment):number {

        if (!gd.ac.check.company.isManager()) return 0

        // 1. try finding in user history
        const userHistory = this.getUserHistory(userId, date)
        if (userHistory && userHistory.laborRate) {
            // console.log("      - based on history")
            return userHistory.laborRate
        }

        // 2. get default
        const userDefaultLaborRate = this.getUserDefaultLaborRate(userId)
        if (userDefaultLaborRate) {
            // console.log("      - based on user current rate")
            return userDefaultLaborRate
        }

        return this.getCompanyLaborRate(date)
        // // 3. no default ? try company history
        // const companyHistory = this.getCompanyHistory(date)
        // if (companyHistory && companyHistory.laborRate) {
        //     console.log("       - based on company history")
        //     return companyHistory.laborRate
        // }
        //
        // // 4. get company default
        // console.log("       - based on company curent rate")
        // return this.getCompanyDefaultLaborRate()

    }

    getCompanyLaborRate(date:Moment):number {

        if (!gd.ac.check.company.isManager()) return 0

        // 3. no default ? try company history
        const companyHistory = this.getCompanyHistory(date)
        if (companyHistory && companyHistory.laborRate) {
            // console.log("       - based on company history")
            return companyHistory.laborRate
        }

        // 4. get company default
        // console.log("       - based on company curent rate")
        return this.getCompanyDefaultLaborRate()

    }

    getUserServiceRate(userId:ID, date:Moment):number {

        if (!gd.ac.check.company.isManager()) return 0

        // 1. try finding in user history
        const userHistory = this.getUserHistory(userId, date)
        if (userHistory && userHistory.serviceRate) {
            // console.log("service.userHistory")
            return userHistory.serviceRate
        }

        // 2. get default
        const userDefaultServiceRate = this.getUserDefaultServiceRate(userId)
        if (userDefaultServiceRate) {
            // console.log("service.userDefault")
            return userDefaultServiceRate
        }

        return this.getCompanyServiceRate(date)

    }

    getCompanyServiceRate(date:Moment):number {

        if (!gd.ac.check.company.isManager()) return 0

        // 3. no default ? try company history
        const companyHistory = this.getCompanyHistory(date)
        if (companyHistory && companyHistory.serviceRate) {
            // console.log("service.companyHistory")
            return companyHistory.serviceRate
        }

        // 4. get company default
        // console.log("service.companyDefault", gd.company.financeDefaultExternalCost)
        return this.getCompanyDefaultServiceRate()

    }


    // Data Sync

    startSync() {
        gd.modelBus.subscribe(EntityType.HOURLY_COST_HISTORY, this, this.onSessionEvent)
    }

    stopSync() {
        gd.modelBus.unsubscribe(this)
    }

    onSessionEvent(method:string, data:any, header:any) {
        hourlyCost_onSessionEvent(this, method, data, header)
    }

    // Calc functions

    private getUserHistory(userId:ID, date:Moment) : HourlyCostHistory | undefined {

        if (!userId || !date) return undefined

        if (!this.userHourlyRateHistory[userId]) return undefined
// console.log("get history userId=", userId, "date=",date.format("YYYY-MM-DD"), date.valueOf())
        const timestamp = date.valueOf()

        const historyRecord = _.find(this.userHourlyRateHistory[userId], (history:HourlyCostHistory)=>{
            // console.log("      ", history.startTimestamp, history.endTimestamp)
            return timestamp >= history.startTimestamp && timestamp <= history.endTimestamp
        })

        return historyRecord
    }

    private getCompanyHistory(date:Moment) : HourlyCostHistory | undefined {

        if (!date) return undefined

        const timestamp = date.valueOf()

        const historyRecord = _.find(this.companyHourlyRateHistory, (history:HourlyCostHistory)=>{
            return timestamp >= history.startTimestamp && timestamp <= history.endTimestamp
        })

        return historyRecord
    }

    private getUserDefaultLaborRate(userId?:ID) : number | undefined {
        if (!userId) return undefined

        const companyUser = gd.session.companyUsers.get(gd.companyId + '-' + userId)
        if (companyUser && companyUser.financeInternalCost) {
            return companyUser.financeInternalCost
        }

        return undefined
    }

    private getUserDefaultServiceRate(userId?:ID) : number | undefined {
        if (!userId) return undefined

        const companyUser = gd.session.companyUsers.get(gd.companyId + '-' + userId)
        if (companyUser && companyUser.financeExternalCost) {
            return companyUser.financeExternalCost
        }

        return undefined
    }

    private getCompanyDefaultLaborRate() : number {
        return gd.company.financeDefaultInternalCost
    }

    private getCompanyDefaultServiceRate() : number {
        return gd.company.financeDefaultExternalCost
    }


    // Export

    getUserHistoryAsCollection(userId:ID):HourlyCostHistoryCollection {
        const collection = new HourlyCostHistoryCollection(this.userHourlyRateHistory[userId] || [])

        return collection
    }

}
